<div class="iframe-container">
  <iframe src="https://monitoring.developer-portal.gtn.tech/app/dashboards#/view/1dc13a6d-455d-4ecf-9567-a62905a51fb2?_g=(refreshInterval%3A(pause%3A!t%2Cvalue%3A60000)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))" 
  height="100%" width="100%"></iframe>
</div>
